import { useAuthStore } from '#modules/auth/store/auth';

export default defineNuxtRouteMiddleware((to) => {
  const { hasLoggedInUser, onboardingCompleted, isTradie } = storeToRefs(useAuthStore());

  if (!hasLoggedInUser.value) return;
  if (isTradie.value) return;

  if (onboardingCompleted.value !== true && to.path !== '/onboarding' && to.path !== '/verify') {
    return navigateTo('/onboarding');
  }
});
